import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const GenerateIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.25 8.33333H16C16.412 8.33333 16.6472 8.80371 16.4 9.13333L9.15 18.8C8.8617 19.1844 8.25 18.9805 8.25 18.5V12.1667C8.25 11.8905 8.02614 11.6667 7.75 11.6667H4C3.58798 11.6667 3.35279 11.1963 3.6 10.8667L10.85 1.2C11.1383 0.815595 11.75 1.01949 11.75 1.5V7.83333C11.75 8.10948 11.9739 8.33333 12.25 8.33333Z"
        fill={fillColor || '#E0E4E4'}
      />
    </svg>
  );
};

export { GenerateIcon };
